export default __webpack_public_path__ + "static/media/annex2.62db4602.png";